import React, { useEffect, useState } from "react";
import { api, fmtPKR } from "../../lib/api";

const STATUS_TONE = {
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
};

export default function DistributorCommissions() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = (status) => {
    const q = status && status !== "all" ? { params: { status } } : {};
    api.get("/distributors/commissions", q).then((r) => setRows(r.data));
  };
  useEffect(() => { load(filter); }, [filter]);

  const totalEarned = rows.filter((r) => r.status === "paid").reduce((s, r) => s + r.distributor_share, 0);
  const totalPending = rows.filter((r) => r.status === "pending").reduce((s, r) => s + r.distributor_share, 0);

  return (
    <div className="space-y-6" data-testid="dist-commissions-page">
      <div>
        <h1 className="font-display text-3xl font-bold">Commissions</h1>
        <p className="text-slate-500 mt-1">Har shop subscription payment ka aap ka share.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs text-slate-500 uppercase tracking-wide font-semibold">Total entries</div>
          <div className="font-display text-2xl font-bold mt-1 tabular">{rows.length}</div>
        </div>
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs text-slate-500 uppercase tracking-wide font-semibold">Earned (paid)</div>
          <div className="font-display text-2xl font-bold mt-1 tabular text-emerald-700">{fmtPKR(totalEarned)}</div>
        </div>
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs text-slate-500 uppercase tracking-wide font-semibold">Pending</div>
          <div className="font-display text-2xl font-bold mt-1 tabular text-amber-700">{fmtPKR(totalPending)}</div>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-md">
        <div className="p-4 border-b border-slate-200 flex flex-wrap gap-1.5">
          {["all", "pending", "paid"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`dist-comm-filter-${f}`}
              className={`px-3 py-1.5 rounded-md text-xs font-semibold border capitalize ${filter === f ? "bg-slate-900 text-white border-slate-900" : "border-slate-200"}`}>
              {f}
            </button>
          ))}
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Date</th>
                <th className="text-left px-4 py-3 font-semibold">Shop</th>
                <th className="text-left px-4 py-3 font-semibold">Plan</th>
                <th className="text-right px-4 py-3 font-semibold">Plan Amount</th>
                <th className="text-right px-4 py-3 font-semibold">Rate</th>
                <th className="text-right px-4 py-3 font-semibold">Your Share</th>
                <th className="text-left px-4 py-3 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-500">No commissions yet.</td></tr>}
              {rows.map((c) => (
                <tr key={c.id} className="border-t border-slate-100" data-testid={`dist-comm-row-${c.id}`}>
                  <td className="px-4 py-3 tabular text-xs">{(c.created_at || "").slice(0, 10)}</td>
                  <td className="px-4 py-3 font-medium">{c.shop_name || c.shop_id?.slice(0, 6)}{c.is_bonus_shop && <span className="ml-1.5 text-amber-700 text-[10px] font-bold">★BONUS</span>}</td>
                  <td className="px-4 py-3 capitalize">{c.plan_id}</td>
                  <td className="px-4 py-3 text-right tabular">{fmtPKR(c.plan_amount)}</td>
                  <td className="px-4 py-3 text-right tabular font-semibold">{c.commission_rate}%</td>
                  <td className="px-4 py-3 text-right tabular font-bold text-emerald-700">{fmtPKR(c.distributor_share)}</td>
                  <td className="px-4 py-3"><span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold border ${STATUS_TONE[c.status]}`}>{c.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
